import Checkbox from './Checkbox';

export default Checkbox;



// WEBPACK FOOTER //
// ./src/client/Components/Checkbox/index.js